type TextEditOperation = {
  op: 'add' | 'remove';
  path: string;
  value?: unknown;
};

const unescapeKey = (key: string): string => key.replace(/~1/g, '/').replace(/~0/g, '~');

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null && !Array.isArray(value)
);

const childOf = (node: unknown, key: string): unknown => {
  if (Array.isArray(node)) return node[Number(key)];
  return isRecord(node) ? node[key] : undefined;
};

// JSON Patch operations that set the text at a path of the draft, adding the objects missing on the
// way; an empty text removes it so the form shows its default text again.
const textEditOperations = (
  draft: unknown,
  path: string,
  value: string,
): TextEditOperation[] => {
  const segments = path.split('/').slice(1);

  if (!value) {
    const current = segments.reduce((node, segment) => childOf(node, unescapeKey(segment)), draft);
    return current === undefined ? [] : [{ op: 'remove', path }];
  }

  const { operations } = segments.slice(0, -1).reduce<{
    node: unknown;
    operations: TextEditOperation[];
  }>(({ node, operations: added }, segment, index) => {
    const child = childOf(node, unescapeKey(segment));
    if (child !== undefined) return { node: child, operations: added };
    const parentPath = `/${segments.slice(0, index + 1).join('/')}`;
    return { node: {}, operations: [...added, { op: 'add', path: parentPath, value: {} }] };
  }, { node: draft, operations: [] });

  return [...operations, { op: 'add', path, value }];
};

export default textEditOperations;
